import { useState } from "react";
import { Input } from "@/components/ui/input";
import { DateField } from "@/components/DateField";
import { ListField } from "@/components/ListField";

export function OptionField({ field, value, onChange, invalid, testId, pickDate, extraPlaceholder }) {
  const [choice, setChoice] = useState(null);
  const [extra, setExtra] = useState("");
  const compose = (idx, text) => {
    const opt = field.options[idx];
    onChange(opt.input ? (text ? `${opt.label} ${text}` : "") : opt.label);
  };

  return (
    <div data-testid={testId} className={`rounded-md border p-3 space-y-2 ${invalid ? "border-brand-red" : "border-input"}`}>
      {field.options.map((opt, idx) => (
        <label key={opt.label} className="flex items-start gap-2.5 text-sm cursor-pointer">
          <input
            type="radio"
            name={testId}
            data-testid={`${testId}-option-${idx}`}
            checked={choice === idx}
            onChange={() => {
              setChoice(idx);
              compose(idx, extra);
            }}
            className="peer sr-only"
          />
          <span
            aria-hidden="true"
            className={`mt-0.5 w-4 h-4 rounded-[4px] border-2 shrink-0 flex items-center justify-center transition-colors ${choice === idx ? "bg-brand-teal border-brand-teal" : "border-slate-400 dark:border-slate-500"}`}
          >
            {choice === idx && <svg viewBox="0 0 12 12" className="w-3 h-3 text-white"><path d="M2 6.5l2.5 2.5L10 3.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>}
          </span>
          <span className="flex-1">
            <span className="first-letter:uppercase inline-block">{opt.label}</span>
            {choice === idx && opt.input === "text" && (
              <Input
                autoFocus
                data-testid={`${testId}-extra`}
                value={extra}
                onChange={(e) => {
                  setExtra(e.target.value);
                  compose(idx, e.target.value);
                }}
                placeholder={extraPlaceholder}
                className="mt-2 bg-background"
              />
            )}
            {choice === idx && opt.input === "list" && (
              <ListField compact subfields={[{ label: extraPlaceholder, input: "text" }]} testId={`${testId}-list`} onChange={(v) => { setExtra(v); compose(idx, v); }} />
            )}
            {choice === idx && opt.input === "date" && (
              <div className="mt-2">
                <DateField
                  testId={`${testId}-extra`}
                  value={extra}
                  placeholder={pickDate}
                  onChange={(v) => {
                    setExtra(v);
                    compose(idx, v);
                  }}
                />
              </div>
            )}
          </span>
        </label>
      ))}
      {value && <p className="text-[11px] text-muted-foreground pt-1 border-t border-border/60">→ {value}</p>}
    </div>
  );
}
